import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import NotesModule from "@/pages/NotesModule";
import TravelModule from "@/pages/TravelModule";
import HomeModule from "@/pages/HomeModule";
import CarDiaryModule from "@/pages/CarDiaryModule";
import WealthCompassModule from "@/pages/WealthCompassModule";
import SponsorLogin from "@/pages/SponsorLogin";
import SponsorDashboard from "@/pages/SponsorDashboard";
import CampaignAnalytics from "@/pages/CampaignAnalytics";
import AdminPanel from "@/pages/AdminPanel";
import AuthVerify from "@/pages/AuthVerify";
import ShareableReport from "@/pages/ShareableReport";
import TokenActivation from "@/pages/TokenActivation";
import { PWAInstallPrompt } from "@/components/PWAInstallPrompt";

function App() {
  return (
    <div className="min-h-screen bg-white">
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth/verify" element={<AuthVerify />} />
          
          {/* Token activation */}
          <Route path="/n/:tokenId" element={<TokenActivation moduleType="notes" />} />
          <Route path="/t/:tokenId" element={<TokenActivation moduleType="travel" />} />
          <Route path="/h/:tokenId" element={<TokenActivation moduleType="home" />} />
          <Route path="/c/:tokenId" element={<TokenActivation moduleType="car" />} />
          <Route path="/f/:tokenId" element={<TokenActivation moduleType="finance" />} />
          
          {/* User routes */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/notes/:tokenId" element={<NotesModule />} />
          <Route path="/travel/:tokenId" element={<TravelModule />} />
          <Route path="/home/:tokenId" element={<HomeModule />} />
          <Route path="/car/:tokenId" element={<CarDiaryModule />} />
          <Route path="/finance/:tokenId" element={<WealthCompassModule />} />
          
          {/* Sponsor routes */}
          <Route path="/sponsor" element={<SponsorLogin />} />
          <Route path="/sponsor/dashboard" element={<SponsorDashboard />} />
          <Route path="/sponsor/campaign/:campaignId" element={<CampaignAnalytics />} />
          
          {/* Admin routes */}
          <Route path="/admin" element={<AdminPanel />} />
          
          {/* Shareable report */}
          <Route path="/report/:reportToken" element={<ShareableReport />} />
        </Routes>
      </BrowserRouter>
      <PWAInstallPrompt />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
